import { FieldProps, RJSFSchema } from "@rjsf/utils";
import { ConfigProvider, Slider } from "antd";

export const HtmlDescriptionField: React.FC<FieldProps<any, RJSFSchema, any>> = (props) => {
  if (!props.schema.description) {
    return null;
  }
  return <div dangerouslySetInnerHTML={{ __html: props.schema.description as any }} />;
};

export const MatrixField: React.FC<FieldProps<any, RJSFSchema, any>> = (props) => {
  const { schema, formData, onChange, uiSchema } = props;
  const optionColumns: Record<string, any>[] = (uiSchema?.["ui:options"]?.columns as any) || [];
  const optionRows: Record<string, any>[] = (uiSchema?.["ui:options"]?.rows as any) || [];
  const handleInputChange = (rowKey: string, columnKey: string) => {
    const updatedData = {
      ...formData,
      [rowKey]: columnKey,
    };
    onChange(updatedData);
  };
  // console.log(schema.title)
  return (
    <>
      {schema.title && (
        <>
          <div className="matrixLabel" style={{ marginBottom: "0.3em" }}>
            {schema.title}
            {schema.description && (
              <small className="matrixDescription" style={{ fontSize: "0.9em" }}>
                <br />
                {schema.description}
              </small>
            )}
          </div>
        </>
      )}

      <style>
        {`
          .matrix-table {
            border-collapse: collapse;
            width: 100%;
            margin-bottom: 1em;
          }
          .matrix-table th,
          .matrix-table td {
            padding: 8px;
          }
          .matrix-table tr:nth-child(even) td {
            background-color: #f9f9f9;
          }
          .matrix-table th {
            background-color: #f2f2f2;
          }
          .matrixLabel {
            font-weight: bold;
          }
          .matrixDescription {
            font-size: 0.8em;
            color: #666;
          }
        `}
      </style>

      <table className="matrix-table">
        <thead>
          <tr>
            <th></th>
            {optionColumns.map((column: Record<string, any>, index: number) => (
              <th key={index}>{column.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {(schema.rows as any)?.enum?.map((row: string, rowIndex: number) => (
            <tr key={rowIndex}>
              <td>{optionRows[rowIndex].label}</td>
              {(schema.columns as any)?.enum.map((column: string, colIndex: number) => (
                <td key={colIndex} align="center">
                  <input
                    type="radio"
                    name={row}
                    value={column}
                    checked={formData?.[row] === column}
                    onChange={() => handleInputChange(row, column)}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <br />
    </>
  );
};

export const SliderField: React.FC<FieldProps<any, RJSFSchema, any>> = (props) => {
  const { schema, formData, onChange, disabled, uiSchema } = props;
  const min = schema?.minimum || 0;
  const max = schema?.maximum || 10;
  const defaultValue = schema?.default || 5;
  const step = schema?.multipleOf || 1;

  const handleSliderChange = (value: number) => {
    onChange(value);
  };

  if (!uiSchema) {
    throw new Error("uiSchema is undefined");
  }
  if (!("ui:options" in uiSchema)) {
    throw new Error("uiSchema is undefined");
  }

  const options = uiSchema["ui:options"];
  if (!(options && "startLabel" in options)) {
    throw new Error("uiSchema is undefined");
  }

  const startLabel = options.startLabel as string;
  const endLabel = options.endLabel as string;

  return (
    <>
      {schema.title && (
        <>
          {/* class="" */}
          <label title="Kompetenz">{schema.title}</label>
        </>
      )}
      {schema.description && (
        <>
          <small className="sliderDescription" style={{ marginBottom: "1em" }}>
            {schema.description}
          </small>
        </>
      )}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "200px 1fr 200px",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          gap: "10px",
          padding: "5px",
        }}
      >
        <span style={{ textAlign: "right" }}>{startLabel ? startLabel : ""}</span>
        <ConfigProvider
          theme={{
            components: {
              Slider: {
                // controlSize: 40,
                railSize: 7, // Adjust the size of controls
              },
            },
          }}
        >
          <Slider
            min={min}
            max={max}
            step={step}
            defaultValue={formData !== undefined ? formData : defaultValue}
            value={formData !== undefined ? formData : defaultValue}
            onChange={handleSliderChange}
            disabled={disabled}
          />
        </ConfigProvider>
        <span>{endLabel ? endLabel : ""}</span>
      </div>
    </>
  );
};

export const HtmlTitleField: React.FC<FieldProps<any, RJSFSchema, any>> = (props) => {
  const { schema } = props;
  if (!schema.title) {
    return null;
  }
  return (
    <>
      <div>
        <span className="header-h5">{schema.title}</span>
        {schema.description && (
          // style={{ fontSize: "0.9em" }}
          <div className="matrixDescription">
            <br />
            {schema.description}
            <br />
            <br />
          </div>
        )}
      </div>
    </>
  );
};

export const getSchemaByPath = (schema: any, path: string): any => {
  return path.split(".").reduce((subSchema, key) => {
    if (!subSchema || !subSchema.properties) return undefined;
    return subSchema.properties[key];
  }, schema);
};

export const transformErrors = (errors: any[], schema: any, t: (lang: string, params?: Record<string, string>) => string) => {
  return errors.map((error) => {
    const path = error.property.startsWith(".") ? error.property.slice(1) : error.property;
    const obj = getSchemaByPath(schema, path);
    const title = obj?.title ? obj.title : path;

    if (error.name === "required") {
      error.message = t("survey.validation.required");
      error.stack = t("survey.validation.required_stack", { field: title });
    }
    if (error.name === "const") {
      error.message = t("survey.validation.constant");
      error.stack = t("survey.validation.constant_stack", { field: title });
    }
    return error;
  });
};
